<!-- <div class="yard-map flex" [ngClass]="isLegendPositionRight? 'flex-direction-row' : 'flex-direction-column'"
  #planOverview> -->
<div class="yard-map" [ngClass]="yardMap?.legendPosition" #planOverview>
  <div #planContainer class="map-container">
    <div class="map-wrapper">
      <div class="image-container">
        <img src="{{urlYardviewMap}}" alt="Werksübersicht" #map (load)="mapLoaded($event)" />
      </div>
      <!-- a-->
      <div class="station" [ngClass]="{'waitingarea':sp.isWaitingArea, 'extended': extendedStationTile}" *ngFor="let sp of yardMap.stations"
        [ngStyle]="sp.calculatedStyle" (click)="selectStation(sp)">

        <div class="station-inner" class="{{sp.statusStyleClasses + ' ' + sp.transportStatusStyle}}">

          <div class="station-identifier" [ngStyle]="{'color': sp.fontColor }">{{ sp.identifier | uppercase }}</div>
          <div class="station-identifier" [ngStyle]="{'color': sp.fontColor }" *ngIf="sp.isWorkingArea">{{sp.subTitle}}
          </div>

          <div *ngIf="sp.isWaitingArea">
            <div class="waitingarea-occupancy-numbers">
              {{ sp.usage }} / {{ sp.capacity }}
            </div>
            <div class="waitingarea-occupancy">
              <div class="waitingarea-occupancy-percentage" [ngStyle]="getWaOccupancyWidth(sp)"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="legend-groups flex flex-direction-column">
    <div class="legend-groups-container">
      <div class="legend-group">
        <div class="flex flex-wrap">
          <div class="legend-entry" *ngFor="let le of yardMap.legendEntries">
            <div class="legend-entry-color" [ngStyle]="{'font-color': le.fontColor, 'background-color': le.color}">
            </div>
            <div class="legend-entry-name">
              {{le.name}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
